module.exports = __webpack_public_path__ + "img/tou.6273130a.png";